var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c(_setup.resolveComponent,{tag:"component",staticStyle:{"height":"100%"},attrs:{"src":_vm.src,"poster":_vm.poster || _setup.placeholder,"description":_vm.description,"preview":_vm.preview,"available-animations":_vm.availableAnimations}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }